import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function WorkflowTransaction() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        getTransactions();
    }, []);
    const getTransactions = () => {
        setLoading(true);
        axios
            .get(baseUrl + "workflow-transaction/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire("Error", "Unable to load workflow transactions", "error");
            });
    };
    const columns = [
        {
            field: "id", headerName: "ID", width: 80
        },
        {
            field: "document_type", headerName: "Document", flex: 1
        },
        {
            field: "document_id", headerName: "Document ID", flex: 1,
        },
        {
            field: "workflow_name", headerName: "Workflow", flex: 1,
            renderCell: (params) =>
                params.row.workflow?.workflow_name

        },
        {
            field: "current_stage_name", headerName: "Current Stage", flex: 1,
            renderCell: (params) =>
                params.row.current_stage?.stage_name
        },
        {
            field: "status", headerName: "Status", width: 130,
            renderCell: (params) => (
                <span

                    className={params.value === "COMPLETED" ? "badge bg-success" : params.value === "REJECTED" ? "badge bg-danger" : "badge bg-warning"}

                >

                    {params.value}

                </span>
            )
        },
        {
            field: "created_by_name", headerName: "Created By", flex: 1,
            renderCell: (params) =>
                params.row.created_by?.username
        },
        {
            field: "created_date", headerName: "Created Date", width: 150
        }
    ];
    const pendingCount = rows.filter(item => item.status === "PENDING").length;
    const completedCount = rows.filter(item => item.status === "COMPLETED").length;
    const rejectedCount = rows.filter(item => item.status === "REJECTED").length;
    const approveCount = rows.filter(item => item.status === "APPROVED").length;
    return (
        <div className="container-fluid mt-3">


            <div className="row mb-3">


                <div className="col-md-4">

                    <div className="card shadow">

                        <div className="card-body text-center">

                            <h6>
                                Pending
                            </h6>

                            <h3 className="text-warning">
                                {pendingCount}
                            </h3>

                        </div>

                    </div>

                </div>
                <div className="col-md-4">

                    <div className="card shadow">

                        <div className="card-body text-center">

                            <h6>
                                Approved
                            </h6>

                            <h3 className="text-success">
                                {approveCount}
                            </h3>

                        </div>

                    </div>

                </div>


                <div className="col-md-4">

                    <div className="card shadow">

                        <div className="card-body text-center">

                            <h6>
                                Completed
                            </h6>

                            <h3 className="text-success">
                                {completedCount}
                            </h3>

                        </div>

                    </div>

                </div>


                <div className="col-md-4">

                    <div className="card shadow">

                        <div className="card-body text-center">

                            <h6>
                                Rejected
                            </h6>

                            <h3 className="text-danger">
                                {rejectedCount}
                            </h3>

                        </div>

                    </div>

                </div>


            </div>


            <div className="card shadow">


                <div className="card-header bg-primary text-white">


                    <h5 className="mb-0">

                        Workflow Transactions

                    </h5>


                </div>


                <div className="card-body">


                    <div
                        style={{
                            height: 600, width: "100%"
                        }}
                    >


                        <ERPDataGrid

                            rows={rows}

                            columns={columns}

                            loading={loading}

                            getRowId={(row) => row.id}


                            pageSizeOptions={[10, 25, 50, 100]}


                            disableRowSelectionOnClick


                        />


                    </div>


                </div>


            </div>


        </div>
    );
}
export default WorkflowTransaction;